<template>
  <div class="info-wrapper">
    <modal
        name="about-survey"
        transition="nice-modal-fade"
        :width="600"
        height="auto"
        :min-height="600"
        :adaptive="true"
        :scrollable="true"
        :reset="true"
        :draggable="false"
        style="z-index: 2"
    >
      <div>
        <div class="modal-content">
          <div class="modal-header">
            <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-hidden="true"
                @click="$modal.hide('about-survey'); $emit('close')"
            >×
            </button>
            <h4 class="modal-title">About this Survey</h4>
          </div>

          <div class="modal-body">
            <p v-if="survey.description" v-html="survey.description_html"></p>
            <p v-else>no description</p>
          </div>
          <div class="modal-footer">
            <button
                type="button"
                class="btn btn-default"
                data-dismiss="modal"
                @click="$modal.hide('about-survey'); $emit('close')"
            >Close
            </button>
          </div>
        </div>
      </div>
    </modal>


    <div class="info-row">

      <div class="info-row__item question-basic-info">
        <div class="question-info__header">{{ survey.name }}</div>
      </div>

      <div class="info-row__item question-additional-info question-additional-info--about-link">
        <a v-if="!popupMode" @click="$modal.show('about-survey')">About this Survey</a>
      </div>

    </div>

    <div class="info-row" v-if="survey.survey_type === 'custom_variables'">
      <div class="info-row__item question-basic-info">
      </div>
      <div class="info-row__item question-additional-info question-additional-info--control-block">
      </div>
    </div>
    <div v-else class="info-row">
      <div class="info-row__item question-basic-info">
        <div class="question-info__description">Question {{ current + 1 }} of {{ total + 1 }}
          <a :href="question.image"
             target="_blank"
             :download="question.image">
            <span v-if="question.image" title="Download Image" class="glyphicon glyphicon-download download-image"
                  aria-hidden="true"></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  components: {
  },
  props: {
    popupMode: {
      type: Boolean,
      default: false
    },
    survey: {
      type: Object,
      default: () => {
      },
    },
    question: {
      type: Object,
      default: () => {
      },
    },
    current: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {}
  },
  methods: {
    downloadImage() {
      this.$emit('download_image')
    }
  },
}
</script>
<style scoped lang="scss">
.info-wrapper {
  width: 100%;
  margin: 0px auto;
  text-align: left;

  .question-info__header {
    small {
      font-size: 14px;
      margin-left: 20px;
    }
  }
}

.info-row {
  display: flex;
  flex-direction: row;
  text-align: left;


  &__item {
    text-align: left;
  }

  .question-basic-info {
    width: 100%;
    align-self: center;
  }

  .question-additional-info {
    min-width: auto;

    &--about-link {
      text-align: right;
      align-self: center;

    @media only screen and (max-width: 768px) {
      text-align: left;
      align-self: start;
    }

    }

    &--control-block {
      align-self: center;
      @media only screen and (max-width: 768px) {
        align-self: start;
        width: 100%;
      }

    }
  }
}

@media only screen and (max-width: 768px) {
  .info-row {
    flex-direction: column;
    padding: 0px;
  }
}


@media (min-width: 992px) {
  .button-wrapper {
    position: relative;
    margin: 0px auto;

    .btn-about {
      position: absolute;
      top: 22px;
      right: 16px;
    }
  }
}

@media (max-width: 992px) {
  .button-wrapper {
    position: relative;
    max-width: 100%;
    margin: 0px auto;
    text-align: center;
  }
}

.v--modal-box {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-body {
  flex: 1;
}

.modal-footer {
  flex: 0;
  height: inherit;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 650px;
  overflow: scroll;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 0;
  border: 0;
  border-radius: 0;
  outline: 0;
}

.close {
  position: absolute;
  top: 18px;
  right: 20px;
  z-index: 999999;
  font-size: 22px;
}

span.download-image {
  font-size: 16px;

  &:hover {
    color: #393939;
    cursor: pointer;
  }
}

</style>
